import dynamic from 'next/dynamic'
const Dialog = dynamic(
	() => import('@qr-front/ui/components/Dialog').then((mod) => mod.Dialog),
	{ ssr: false },
)
const DialogContent = dynamic(
	() =>
		import('@qr-front/ui/components/Dialog').then(
			(mod) => mod.DialogContent,
		),
	{ ssr: false },
)

import { useAtom, useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

import { qrCodesApi } from '@/generator/shared'

import { getQrNameErrorMessage } from '../../../utils/getQrNameErrorMessage'
import { editQrNameDialogAtom, editQrNameDialogAtomData } from '../dialogsState'
import { nameValidationSchema } from '../TableRow/commonElements'
import { EditableField } from '../TableRow/EditableField'

export const EditQrNameDialog = () => {
	const t = useTranslations()

	const [serverError, setServerError] = useState<string>('')
	const [open, setOpen] = useAtom(editQrNameDialogAtom)
	const editQrNameDialogData = useAtomValue(editQrNameDialogAtomData)

	if (!editQrNameDialogData) return null

	const { name, row, table } = editQrNameDialogData

	const handleSave = async (newValue: string) => {
		try {
			setServerError('')
			await qrCodesApi.putQr(row.original.id, {
				name: newValue,
				content: row.original.content,
				qrDesign: row.original.qrDesign,
			})

			if (table.options.meta?.updateData) {
				table.options.meta.updateData(row.index, 'name', newValue)
			}
			setOpen(false)
		} catch (error: unknown) {
			setServerError(getQrNameErrorMessage(error, t))
		}
	}

	return (
		<Dialog open={open} onOpenChange={() => setOpen(!open)}>
			<DialogContent
				closeButtonLabel={t('ui__popup__close_button')}
				className="p-4"
				onOpenAutoFocus={(e) => {
					e.preventDefault()
				}}
			>
				<div className="flex flex-col items-center justify-center gap-6 p-2">
					<div className="flex w-full justify-start">
						<h3 className="type-heading-3">
							{t('dashboard__edit__qr_name__dialog_title')}
						</h3>
					</div>
					<div className="w-full">
						<EditableField
							value={name}
							onSave={(value) => {
								handleSave(value)
							}}
							onCancel={() => {
								setServerError('')
								setOpen(false)
							}}
							validationSchema={nameValidationSchema(t)}
							label={t(
								'dashboard__edit__qr_name__dialog__qr_name__field_label',
							)}
							placeholder={t(
								'generator__content_form_section__qr_name__field_placeholder',
							)}
							serverError={serverError}
						/>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}
